var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 688",
    style: {
      enableBackground: "new 0 0 595.3 688"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M308.6,362.7c0.1,0.8,0.2,1.5,0.3,2.3c0.1,0.3,0.2,0.6,0.3,1l0,0c0.1,0.8,0.2,1.5,0.3,2.3 c0.2,1.4,0.9,2.7,2.3,2.8c0.8,0.1,1.8-1,2.6-1.6c0.1,0,0.2,0,0.3,0c0.5-0.7,1.2-1.4,1.3-2.2c1.1-5.4,2-10.7,3-16.1 c2.2-11.9,4.5-23.9,6.7-35.8c1-5.5,2.1-11,3.1-16.5c0.9-5,1.9-10.1,2.8-15.1c0.1-0.3-0.2-0.6-0.4-1c0.4-0.8,0.6-1.6,1.2-2.2 c0.7-0.8,1.7-1.5,2.6-2.2c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.2,0,0.3-0.1c1.1-0.1,2.3-0.4,3.4-0.3c5.8,0.6,11.6,1.3,17.3,2 c4.8,0.6,8.1,3.6,8.6,8.4c0.3,2.4-0.1,5-0.5,7.5c-1.2,7.5-2.5,15-3.8,22.5c0,0.2-0.2,0.5-0.2,0.7c-0.4,1.9-0.9,3.9-1.3,5.8 c0.1,0,0.3,0.1,0.4,0.1c0.3-1.6,0.6-3.2,0.9-4.7c0.4,0,0.9,0,1.3-0.1c0.1,2.3,0.1,4.5,0.2,6.8c-0.9,0.1-1.8,0.2-2.7,0.3 c0-0.3-0.1-0.6-0.1-1.1c-3.4,0-6.8,0-10.1,0c0-4.4,0-8.8,0-13.2c0-0.3-0.2-0.5-0.3-0.8c-3.6-0.3-7.1-0.6-10.7-0.8 c-0.2,0-0.4,0.4-0.6,0.6c0,0.4,0,0.9,0.1,1.3c0,1.7,0,3.4-0.1,5.1c-0.1,1.1,0.2,1.4,1.4,1.4c3.3,0.1,3.3,0.2,3.3,3.4 c0,0.3,0,0.6,0,0.9c0.1,1.6,0.5,2,2.1,2.1c1.5,0,3.1,0,4.6,0l0.1,0c0,0,0.1,0,0.1,0c0,0.2,0,0.4,0,0.6c0,0.3,0,0.5,0,0.8 c0,0.1,0,0.2-0.1,0.4c-0.1,0.3-0.2,0.5-0.2,0.8c0,3,0,6,0,9c0.1,0.8,0.2,1.6,0.3,2.4c-2.3,0-4.5,0-6.8,0c0-1,0-2,0-3 c0-0.3-0.3-0.7-0.5-1c-0.7,0-1.4,0-2-0.2c-1-0.3-1.3,0.2-1.2,1c0.1,3.9-0.5,3.1,3,3.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0.1 c0,2.4,0,4.8,0,7.3c0,0.5,0.4,1.3,0.7,1.3c2.4,0,4.8-0.1,7.2-0.2c0.2-0.4,0.5-0.7,0.5-1.1c0.1-1.6,0-3.2,0-4.7c1.1,0,2.2,0,3.3,0 c0.8,0,1.1,0.3,1.1,1.1c0,1,0.2,2.1,0.3,3.1c0,0.8,0,1.7,0,2.5c-0.2,1-0.1,2.3-0.7,2.9c-0.5,0.6-1.8,0.4-2.8,0.6 c-0.1,0.7-0.4,1.4-0.3,2.1c0,0.3,0.7,0.9,1,0.8c1.6-0.2,1.6,0.6,1.4,1.8c-2.9,16.4-5.7,32.8-8.6,49.3c-0.9,5.2-4.2,8.3-9.4,8.9 c-16.9,2-33.8,4.1-50.7,6c-1.6,0.2-3.2-0.3-4.8-0.5c-0.2-0.2-0.5-0.4-0.7-0.5c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.4-0.8-0.7-1.1-1.1 c-0.8-1.1-1.5-2.2-2.2-3.3c0,0,0.1-0.1,0.1-0.1c-0.3-2-0.4-4-0.8-5.9c-1.7-8.2-3.6-16.4-5.3-24.6c-0.7-3.4-1.2-6.8-1.9-10.2 c-2.6-12.5-5.3-25.1-8-37.6c-0.9-4.3-1.5-8.6-2.4-12.8c-2.5-12.1-5-24.2-7.4-36.3c-0.9-4.5-2.7-9-1.2-13.7c0-0.1-0.3-0.3-0.4-0.4 c0.2-0.5,0.3-1,0.6-1.4c0.7-0.9,1.6-1.8,2.4-2.7c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.2-0.1,0.3-0.2,0.5-0.2c0,0,0,0,0,0 c0.3-0.2,0.6-0.3,1-0.5c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1,0,0.2-0.1c0.2,0,0.3-0.1,0.5-0.1 c0.3-0.1,0.5-0.1,0.8-0.2c0.3-0.1,0.7-0.1,1-0.2c4.1,0.5,8.2,1,12.3,1.5c6.2,0.9,12.6,0.6,18.6,2.9c0,0,0,0,0,0 c0.5,0.4,1,0.8,1.5,1.2l0,0.1c0,0,0-0.1,0-0.1c0.4,0.4,0.8,0.8,1.1,1.2c0,0,0,0,0,0c0.2,0.3,0.4,0.6,0.6,0.9c0,0,0,0,0,0 c0.2,0.3,0.4,0.6,0.6,0.9c0,0,0,0,0,0c1,4.6,2,9.2,3,13.8c0.8,3.8,1.6,7.5,2.4,11.3c0.1,0.2,0.2,0.5,0.3,0.7c0,0.3-0.1,0.7,0,1 c1,5.5,2.1,10.9,3.2,16.4c0.2,1,0.6,2,0.9,2.9c0.2,1.5,0.5,3.1,0.7,4.6c1.1,5.8,2.3,11.6,3.4,17.4c0.3,1.2,0.6,2.5,0.9,3.7 c0.3,2.1,0.6,4.1,1,6.2C307.4,357.7,308,360.2,308.6,362.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M271.1,414c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.3-0.6l-0.1-0.1c0,0,0-0.1,0-0.1 c-0.1-0.2-0.1-0.5-0.2-0.7c-0.9-4-1.8-7.9-2.6-11.9c-3.5-16.6-6.9-33.2-10.3-49.9c-4.6-22.2-9.2-44.3-13.7-66.5 c-0.4-1.8-0.1-3.6-0.1-5.4c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1,0-0.2c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1,0-0.2 c0.2-0.4,0.3-0.8,0.5-1.2c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0.5-0.1,1.1-0.3,1.6-0.4c0.8-0.2,1.6-0.5,2.4-0.8 c-0.4,1.9-1.4,3.8-0.9,5.9c0.2,0.8,0.4,1.6,0.6,2.3c3,14.7,6.1,29.5,9.1,44.2c2.6,12.4,5.2,24.8,7.7,37.1 c3.3,15.8,6.5,31.6,9.8,47.4c0.3,1.4,0.9,2.7,1.3,4c0,0-0.1,0.1-0.1,0.1c-0.7-0.1-1.4-0.1-2-0.2c-0.8-0.1-1.6-0.4-2.5-0.5 c-0.1-0.2-0.3-0.5-0.4-0.7C271.2,414.3,271.1,414.2,271.1,414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M307.3,246.8c4.4-2.9,7.5-1.2,10,2c1.8,2.3,3.5,4.7,5.3,7.1c1.6,2.1,2.1,4.6,2,7.2 c0,0.3-0.2,0.6-0.4,0.9c-0.3,0.8-0.6,1.6-0.8,2.4c0,0,0,0,0,0c-1.1,1-2.2,1.9-3.2,2.9c-2.2,2.1-3.7,5-7.3,5.3 c-0.1,0-0.2,0.3-0.3,0.4c-0.7-0.1-1.3-0.2-2-0.3c-4.4-2.7-6.8-7.2-9.9-11.1c0.9,0.3,0.6-0.2,0.4-0.6c-0.9-2.4-1.4-4.8-0.9-7.4 c0-0.1-0.2-0.2-0.3-0.3c0,0-0.1-0.1-0.1-0.1c0.1-0.3,0.1-0.7,0.3-0.9c1.9-2,3.9-4,5.8-6c0.4-0.4,0.8-0.9,1.2-1.4 C307.1,246.9,307.2,246.8,307.3,246.8C307.2,246.8,307.3,246.8,307.3,246.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M314.7,369.4c-0.1,0-0.2,0-0.3,0c-0.5-0.3-0.9-0.8-1.4-0.7c-2.2,0.3-3.5-0.5-3.9-2.7c0,0,0,0,0,0 c0-0.2,0-0.3,0.1-0.5c0.5-1.9,1-3.8,1.4-5.7c3.7-19,7.3-38.1,11-57.1c1-5.3,2-10.7,3.1-16c0.2-0.8,0.5-1.6,0.8-2.4 c0.8-0.1,1.7-0.1,2.5-0.2c1-0.1,1.9-0.4,2.9-0.6c-0.5,2.8-0.9,5.5-1.4,8.3c-2,10.5-4,21-6,31.5c-2.2,11.7-4.4,23.4-6.6,35 C316.1,361.8,315.4,365.6,314.7,369.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M366.2,343.9c-0.9,0.1-1.8,0.2-2.7,0.2c-0.1,0-0.1-0.1-0.2,0c-0.1-1.3-0.2-2.7-0.3-4 c-0.1-0.2-0.3-0.6-0.4-0.6c-0.9-0.1-1.9-0.1-2.8-0.1c0-0.6,0-1.2,0-1.9c0.5-0.1,1.1-0.2,1.6-0.4c0.4-0.1,0.7-0.4,1.1-0.6 c0.5-0.2,1.1-0.3,1.7-0.5c0-1,0.1-2.1,0.1-3.1c0.9-0.1,1.7-0.2,2.5-0.3c0.3-0.2,0.8-0.4,0.7-0.5c-0.1-1.4-0.3-2.8-0.4-4.2 c1.2,0,2.4,0,3.7,0c0,1.8,0,3.4,0,5.2c-2.1,0.1-4.1,0.2-6.2,0.4c0,0.9,0,1.8,0,2.9c2.5,0,5,0,7.7,0c0,2.6,0,5,0,7.6 c-1.8,0-3.6,0-5.4,0c0.7-1.5,0.6-6.6-0.6-7.5c0.1,2.7,0.2,5.1,0.3,7.5c0,0,0,0,0,0C366.4,343.8,366.3,343.8,366.2,343.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M300.7,263.7c3.2,3.8,5.5,8.4,9.9,11.1c-0.4,0.2-0.8,0.4-1.3,0.6c-1.2,0.5-2.5,1-3.8,1.5 c-1-0.6-2.3-0.9-3.1-1.8c-2.6-3.1-5-6.3-7.4-9.5c0.3-0.4,0.5-0.9,0.9-1.1c1.3-0.6,2.7-1.1,4.1-1.7 C300.3,263.1,300.5,263.4,300.7,263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M366.8,332.6c-0.8,0.1-1.6,0.2-2.5,0.3c0,1-0.1,2.1-0.1,3.1c-0.6,0.2-1.1,0.3-1.7,0.5 c-2.5,0-5,0-7.6,0c0-2.3,0-4.6,0-6.9c1.2,0,2.3,0,3.5,0c0.2,0.1,0.4,0.2,0.6,0.3c1.7,0,3.4,0,5.1,0c0-0.2,0-0.4,0-0.6 c-1.3,0-2.6,0-3.8,0c0-0.1,0-0.2-0.1-0.2c0-0.2,0.1-0.4,0.1-0.6c2.1-0.1,4.3-0.2,6.4-0.3C366.7,329.6,366.7,331.1,366.8,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M300.1,262.8c-1.4,0.5-2.8,1-4.1,1.7c-0.4,0.2-0.6,0.7-0.9,1.1c-1.4-2.1-1.8-4.4-1.1-6.9 c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1,0-0.2c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.2-0.5,0.3-0.7 c1.6-0.5,3.3-1,4.9-1.5c0,0,0.1,0.1,0.1,0.1C298.7,257.9,298.9,260.4,300.1,262.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M362.7,319.8c1.5,0,3.1,0,4.8,0c0,2.3,0,4.4,0,6.5c-1.2,0.1-2.4,0.2-3.6,0.3c-0.3,0-0.5,0-0.8,0 c0-0.1,0-0.3-0.1-0.4C362.9,324.1,362.8,321.9,362.7,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M351.1,329.2c0.8,0,1.5-0.1,2.3-0.1c0,2.6,0,5.1,0.1,7.7c-0.7,0-1.4,0-2.1,0.1 c-0.6,0.1-1.1,0.2-1.7,0.3c0-2.6,0-5.2,0-7.7C350.1,329.3,350.6,329.2,351.1,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M299.8,255.2c-1.6,0.5-3.3,1-4.9,1.5c1.5-1.6,3-3.2,4.5-4.9c2.1-2.5,4.9-3.9,7.8-5 c-0.4,0.5-0.8,1-1.2,1.4c-1.9,2-3.9,4-5.8,6C299.9,254.5,299.9,254.9,299.8,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M330.8,283.3c-1,0.2-1.9,0.5-2.9,0.6c-0.8,0.1-1.7,0.1-2.5,0.2c0.6-2,2-3.4,3.9-4.2 c1.9-0.7,3.9-1.1,5.8-1.7c-0.9,0.7-1.8,1.4-2.6,2.2c-0.5,0.6-0.8,1.5-1.2,2.2C331.2,282.9,331,283.1,330.8,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M287.4,272.9c-6-2.3-12.4-2-18.6-2.9c-4.1-0.6-8.2-1-12.3-1.5c2.7,0.2,5.4,0.3,8.1,0.6 c6.3,0.7,12.5,1.4,18.7,2.2C284.7,271.5,286,272.4,287.4,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M296.6,302.2c-0.8-3.8-1.6-7.6-2.4-11.3c-1-4.6-2-9.2-3-13.8c0.7,2.2,1.6,4.3,2,6.6 c1.2,5.8,2.3,11.7,3.4,17.5C296.7,301.4,296.6,301.8,296.6,302.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M271.6,415.2c0.8,0.2,1.6,0.4,2.5,0.5c0.7,0.1,1.4,0.1,2,0.2c0.7,1.1,1.4,2.2,2.2,3.3 c0.3,0.4,0.7,0.7,1.1,1.1c-2.4-1-5-1.7-6.8-3.7C272.2,416.2,272,415.7,271.6,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M248.6,274.7c-0.8,0.3-1.6,0.5-2.4,0.8c-0.5,0.2-1.1,0.3-1.6,0.4c0.7-2,2.2-3.3,4-4.3 c1-0.6,2.1-1,3.2-1.5c-0.8,0.9-1.6,1.7-2.4,2.7c-0.3,0.4-0.4,0.9-0.6,1.4C248.8,274.4,248.7,274.6,248.6,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M301,323.1c-0.3-1-0.7-1.9-0.9-2.9c-1.1-5.4-2.1-10.9-3.2-16.4c-0.1-0.3,0-0.6,0-1 c0.6,3,1.3,5.9,1.9,8.9C299.6,315.6,300.2,319.4,301,323.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M312.6,275c0.1-0.2,0.2-0.4,0.3-0.4c3.5-0.3,5.1-3.2,7.3-5.3c1.1-1,2.2-2,3.2-2.9 c-0.6,0.7-1.1,1.5-1.7,2.1c-1.3,1.5-2.8,2.8-4.1,4.3c-1.2,1.4-2.7,2.2-4.4,2.5C313,275.2,312.8,275.1,312.6,275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M305.1,345.2c-1.1-5.8-2.3-11.6-3.4-17.4c0.4,1.4,0.8,2.7,1.1,4.1c0.8,3.8,1.5,7.6,2.2,11.3 C305.1,343.9,305,344.5,305.1,345.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M355.5,349c0-0.8,0-1.7,0-2.5c0.1-0.1,0.2-0.1,0.3-0.2c0.7,0,1.3,0,2.1,0c0-2.4,0-4.7,0-6.9 c0.4,0,0.7,0,1.1-0.1c0,0.2-0.1,0.4-0.1,0.6c0,1.9,0,3.9,0,5.8c0.1,0.2,0.2,0.5,0.3,0.5c1.4,0.1,2.8,0.1,4.2,0.1 c-1.7,0.1-3.3,0.2-5,0.2c-0.8,0-1.6,0-2.4,0C355.8,347.6,355.6,348.3,355.5,349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373234"
    },
    d: "M312.6,275c0.2,0.1,0.4,0.2,0.6,0.3c-2.3,0.6-4.7,1.2-7,1.7c-0.2,0-0.4-0.1-0.6-0.2 c1.3-0.5,2.5-1,3.8-1.5c0.4-0.2,0.9-0.4,1.3-0.6C311.3,274.8,312,274.9,312.6,275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M349.3,326.3c0-0.2,0-0.4,0-0.6c0,0,0,0,0,0c3.4,0,6.7,0,10.1,0c0.1,0.6,0.1,0.9,0.1,1.1 c-1,0.1-2,0.2-3,0.3c-0.3-0.1-0.6-0.1-0.9-0.2c0.2-0.1,0.4-0.2,0.7-0.2c0-0.1,0-0.3,0-0.4C354,326.3,351.7,326.3,349.3,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M308.6,362.7c-0.6-2.5-1.2-5-1.7-7.5c-0.4-2.1-0.6-4.1-1-6.2c0.8,3.7,1.6,7.4,2.3,11.1 C308.4,360.9,308.5,361.8,308.6,362.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M353.4,336.8c0-2.6,0-5.1-0.1-7.7c0.3,0,0.6,0,0.9-0.1c0,0.2,0,0.4,0,0.5c0,2.3-0.1,4.6-0.1,6.9 C353.9,336.6,353.7,336.7,353.4,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M366.5,343.8c-0.1-2.4-0.2-4.8-0.3-7.5c1.2,0.9,1.3,6,0.6,7.5c0,0-0.1,0-0.1,0L366.5,343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M362.7,319.8c0.1,2.2,0.2,4.3,0.3,6.5c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0-0.2,0-0.3,0 c-0.1-2.3-0.1-4.5-0.2-6.8C362.3,319.8,362.5,319.8,362.7,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#453C3D"
    },
    d: "M349.3,326.3c2.3,0,4.6,0,7,0c0,0.1,0,0.3,0,0.4c-0.2,0.1-0.4,0.2-0.7,0.2c-2,0.1-4,0.1-6.1,0.2 c-0.1-0.1-0.2-0.1-0.3-0.1C349.3,326.9,349.3,326.6,349.3,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C4C49"
    },
    d: "M362.2,326.6c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.3,0,0.5,0,0.8,0c1,0.1,2,0.2,3,0.3 c-3.5,0.1-6.9,0.2-10.4,0.3c1-0.1,2-0.2,3-0.3C360.4,326.8,361.3,326.7,362.2,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M354.3,329.6c0-0.2,0-0.4,0-0.5c1.9,0,3.7,0.1,5.6,0.1c0.1,0,0.2,0,0.3,0.1c1.3,0,2.6,0,3.8,0 c0,0.2,0,0.4,0,0.6c-1.7,0-3.4,0-5.1,0c-0.2-0.1-0.4-0.2-0.6-0.3c-1.2,0-2.3,0-3.5,0C354.7,329.6,354.5,329.6,354.3,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M366.8,332.6c0-1.5-0.1-3-0.1-4.5c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.2,0,0.3,0 c0.2,1.4,0.3,2.8,0.4,4.2C367.5,332.2,367.1,332.4,366.8,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M363.3,346.5c-1.4,0-2.8,0-4.2-0.1c-0.1,0-0.2-0.3-0.3-0.5c1.5,0,3,0,4.5,0c0.1,0.1,0.1,0.2,0.2,0.3 C363.4,346.2,363.3,346.3,363.3,346.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M360.7,319.9c-0.3,1.6-0.6,3.2-0.9,4.7c-0.1,0-0.3-0.1-0.4-0.1c0.4-1.9,0.9-3.9,1.3-5.8 C360.7,319.1,360.7,319.5,360.7,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M366.9,326.9c-1-0.1-2-0.2-3-0.3c1.2-0.1,2.4-0.2,3.6-0.3C367.3,326.5,367.1,326.7,366.9,326.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M366.8,327.8c0,0.1-0.1,0.2-0.2,0.3c-2.1,0.1-4.3,0.2-6.4,0.3C362.4,328.2,364.6,328,366.8,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M323.4,266.3c0.3-0.8,0.6-1.6,0.8-2.4C324,264.8,323.7,265.5,323.4,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M349.3,327.1c0.1,0,0.2,0,0.3,0.1c0,0.6,0.1,1.1,0.1,1.7c0.5,0.1,1,0.2,1.4,0.3 c-0.5,0.1-1,0.1-1.5,0.2c-0.1-0.6-0.2-1.3-0.4-1.9C349.3,327.4,349.3,327.3,349.3,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M288.9,274c-0.5-0.4-1-0.8-1.5-1.2C287.9,273.3,288.4,273.7,288.9,274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M363.5,346.1c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.6,0-1.2,0-1.8c0.1,0,0.2,0,0.2,0 C363.5,344.8,363.5,345.5,363.5,346.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M290,275.3c-0.4-0.4-0.8-0.8-1.1-1.2C289.3,274.5,289.6,274.9,290,275.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M291.2,277c-0.2-0.3-0.4-0.6-0.6-0.9C290.8,276.4,291,276.7,291.2,277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M279.8,420.4c0.2,0.2,0.5,0.4,0.7,0.5C280.3,420.8,280.1,420.6,279.8,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M255.5,268.6c-0.3,0.1-0.5,0.1-0.8,0.2C255,268.8,255.3,268.7,255.5,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M290.6,276.1c-0.2-0.3-0.4-0.6-0.6-0.9C290.2,275.5,290.4,275.8,290.6,276.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M309.2,365.4c0,0.2,0,0.3-0.1,0.5c-0.1-0.3-0.2-0.6-0.3-1C309,365.1,309.1,365.3,309.2,365.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M270.7,413.2c0.1,0.2,0.2,0.4,0.3,0.6C270.9,413.6,270.8,413.4,270.7,413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M270.5,412.3c0.1,0.2,0.1,0.5,0.2,0.7C270.6,412.8,270.5,412.5,270.5,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M366.2,343.9c0.1,0,0.2,0,0.3-0.1C366.4,343.8,366.3,343.8,366.2,343.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M252,270.1c-0.1,0-0.1,0-0.1,0.1C251.8,270.1,251.9,270,252,270.1L252,270.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M360.1,329.2c-0.1,0-0.2,0-0.3-0.1c0.1-0.1,0.2-0.1,0.2-0.2C360.1,329,360.1,329.1,360.1,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M243.7,278.3c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1C243.7,278.5,243.7,278.4,243.7,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M335.9,278c-0.1,0-0.2,0-0.3,0.1C335.8,278.1,335.8,278,335.9,278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M244,277.4c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1C243.9,277.6,243.9,277.5,244,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M244.5,276c0,0-0.1,0.1-0.1,0.2c0,0,0-0.1,0-0.1L244.5,276z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B04821"
    },
    points: "252.5,269.8 252.5,269.8 252.5,269.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M271.1,414c0.1,0.1,0.1,0.3,0.2,0.4C271.2,414.3,271.1,414.2,271.1,414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M253.7,269.2c-0.1,0-0.1,0.1-0.2,0.1C253.5,269.2,253.6,269.2,253.7,269.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#846C66"
    },
    d: "M254.3,269c-0.1,0-0.1,0-0.2,0.1C254.1,269,254.2,268.9,254.3,269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M294.1,258.5c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1C294,258.7,294.1,258.6,294.1,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M294.6,257.4c-0.1,0.2-0.2,0.3-0.3,0.5C294.4,257.7,294.5,257.6,294.6,257.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B04821"
    },
    points: "307.3,246.8 307.2,246.8 307.2,246.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8671"
    },
    d: "M248.6,274.7c0.1-0.2,0.2-0.3,0.3-0.5c0.1,0.1,0.4,0.3,0.4,0.4c-1.5,4.7,0.3,9.2,1.2,13.7 c2.4,12.1,5,24.2,7.4,36.3c0.9,4.3,1.5,8.6,2.4,12.8c2.6,12.5,5.3,25.1,8,37.6c0.7,3.4,1.2,6.8,1.9,10.2c1.7,8.2,3.6,16.4,5.3,24.6 c0.4,1.9,0.5,3.9,0.8,5.9c-0.5-1.3-1-2.7-1.3-4c-3.3-15.8-6.5-31.6-9.8-47.4c-2.6-12.4-5.2-24.8-7.7-37.1 c-3-14.7-6.1-29.5-9.1-44.2c-0.2-0.8-0.4-1.6-0.6-2.3C247.2,278.5,248.2,276.7,248.6,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8671"
    },
    d: "M330.8,283.3c0.2-0.2,0.3-0.4,0.5-0.6c0.1,0.3,0.4,0.7,0.4,1c-0.9,5-1.8,10.1-2.8,15.1 c-1,5.5-2.1,11-3.1,16.5c-2.2,11.9-4.5,23.9-6.7,35.8c-1,5.4-1.9,10.8-3,16.1c-0.2,0.8-0.9,1.4-1.3,2.2c0.7-3.8,1.4-7.6,2.1-11.4 c2.2-11.7,4.4-23.4,6.6-35c2-10.5,4-21,6-31.5C329.9,288.8,330.4,286,330.8,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M337.7,311.5c0.2-0.2,0.4-0.6,0.6-0.6c3.6,0.2,7.2,0.5,10.7,0.8c-0.2,0.2-0.4,0.4-0.6,0.6 c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.2c0,4.2,0,8.4,0,12.5c-1.4,0-2.8,0-4.2-0.1c-1-0.1-1.4-0.5-1.3-1.6c0.1-1.1,0.1-2.2,0-3.3 c0-0.4-0.6-0.8-0.9-1.1c0.1-0.2,0.1-0.4,0.2-0.6c0-1.6,0-3.3,0-4.9c0-0.2-0.1-0.3-0.1-0.5c1.8-0.3,3.6-0.5,5.4-0.8 c0-0.1,0-0.1,0-0.2C344.2,311.9,341,311.7,337.7,311.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M349.4,339.7c-0.4,0.3-0.8,0.8-1.2,0.9c-1.8,0.1-3.6,0-5.5,0c0,2.2,0,4.4,0,6.5 c0,0.1,0.5,0.3,0.8,0.4c2.1,0,4.2,0,6.3,0c0.1,0.2,0.3,0.4,0.4,0.6c-2.4,0.1-4.8,0.2-7.2,0.2c-0.2,0-0.7-0.9-0.7-1.3 c-0.1-2.4,0-4.8,0-7.3c0.1,0,0.2,0,0.3-0.1C344.9,339.7,347.1,339.7,349.4,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M348.4,325.2c0-4.2,0-8.4,0-12.5c0-0.1,0-0.2,0-0.3c0.2-0.2,0.4-0.4,0.6-0.6 c0.1,0.3,0.3,0.5,0.3,0.8c0,4.4,0,8.8,0,13.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0C348.9,325.5,348.7,325.4,348.4,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M348.4,325.2c0.2,0.2,0.5,0.4,0.7,0.6c-1.5,0-3.1,0-4.6,0c-1.6,0-2-0.5-2.1-2.1c0-0.3,0-0.6,0-0.9 c0-3.3,0-3.3-3.3-3.4c-1.1,0-1.4-0.4-1.4-1.4c0.1-1.7,0.1-3.4,0.1-5.1c0.1,0,0.1,0,0.1,0.1c0,1.9,0,3.8,0,5.8 c1.5,0.1,2.8,0.2,4.1,0.3c0.3,0.4,0.8,0.7,0.9,1.1c0.1,1.1,0.1,2.2,0,3.3c-0.1,1.1,0.4,1.5,1.3,1.6 C345.6,325.1,347,325.1,348.4,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1B1F"
    },
    d: "M337.9,313c0-0.1-0.1-0.1-0.1-0.1c0-0.4,0-0.9-0.1-1.3c3.2,0.2,6.5,0.3,9.7,0.5c0,0.1,0,0.1,0,0.2 c-1.8,0.3-3.6,0.5-5.4,0.8C340.7,313,339.3,313,337.9,313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M309.2,366c0.4,2.2,1.7,3,3.9,2.7c0.4-0.1,0.9,0.5,1.4,0.7c-0.9,0.6-1.8,1.6-2.6,1.6 c-1.4-0.1-2.1-1.4-2.3-2.8C309.3,367.5,309.2,366.7,309.2,366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M350.5,341.8c0.3,0,0.6,0,0.9,0c1.4,0.1,3.4-0.4,4,0.3c0.7,0.8,0.3,2.7,0.4,4.1c0,0,0,0.1,0,0.1 c-0.1,0-0.2,0.1-0.3,0.2c-0.1-1-0.3-2-0.3-3.1c0-0.8-0.3-1.1-1.1-1.1c-1.1,0-2.2,0-3.3,0C350.7,342.2,350.6,342,350.5,341.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M350.5,341.8c0.1,0.2,0.2,0.4,0.3,0.6c0,1.6,0,3.2,0,4.7c0,0.4-0.3,0.7-0.5,1.1 c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1-1.9-0.1-3.9-0.2-5.8C349.9,341.8,350.2,341.8,350.5,341.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M342.1,339.7c-0.1,0-0.2,0-0.3,0c-3.5-0.1-2.9,0.7-3-3.2c0-0.8,0.3-1.3,1.2-1c0.6,0.2,1.3,0.1,2,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.7,0.2-1.5,0.3-2.2,0.5c0,0.9,0,1.7,0,2.7c0.8,0,1.5,0,2.1,0C341.8,339.3,342,339.5,342.1,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M349.7,337.1c-0.2,0.1-0.4,0.1-0.5,0.2c0-3,0-6,0-9c0-0.3,0.1-0.5,0.2-0.8c0.1,0.6,0.2,1.3,0.4,1.9 C349.6,332,349.6,334.5,349.7,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9A88"
    },
    d: "M341.8,336c0.1-0.1,0.2-0.2,0.3-0.3c0.2,0.3,0.5,0.7,0.5,1c0.1,1,0,2,0,3c-0.1,0-0.2,0-0.3,0.1 c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.4-0.5-0.5C341.7,338.1,341.7,337,341.8,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8671"
    },
    d: "M300.1,262.8c-1.2-2.5-1.4-5-0.2-7.5c0.1,0.1,0.4,0.3,0.3,0.3c-0.5,2.6,0,5,0.9,7.4 c0.1,0.4,0.5,0.9-0.4,0.6C300.5,263.4,300.3,263.1,300.1,262.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M363.3,344.1c0,0.6,0,1.2,0,1.8c-1.5,0-3,0-4.5,0c0-1.9,0-3.9,0-5.8c1.4,0,2.8,0,4.2,0 C363.1,341.4,363.2,342.7,363.3,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M359.8,337.5c-0.5-0.1-1-0.3-1.5-0.3c-2.1-0.1-4.1,0-6.2-0.1c-0.3,0-0.6-0.2-0.9-0.3 c0.7,0,1.4,0,2.1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.2,0,0.5,0,0.7,0c2.5,0,5,0,7.6,0c-0.4,0.2-0.7,0.5-1.1,0.6 C360.8,337.3,360.3,337.4,359.8,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M363,340c-1.4,0-2.8,0-4.2,0c0.1-0.2,0.1-0.4,0.1-0.6c0.3,0,0.6,0,0.8,0c0.9,0,1.9,0,2.8,0.1 C362.7,339.5,362.9,339.8,363,340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M354.9,336.5c-0.2,0-0.5,0-0.7,0c0-2.3,0.1-4.6,0.1-6.9c0.2,0,0.4,0,0.6,0 C354.9,331.9,354.9,334.2,354.9,336.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M358.4,329.6c0.2,0.1,0.4,0.2,0.6,0.3C358.8,329.7,358.6,329.6,358.4,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M363,326.6c-0.2,0-0.3,0-0.5,0c0.1-0.1,0.3-0.2,0.4-0.4C363,326.4,363,326.5,363,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M355.7,346.4c0,0,0-0.1,0-0.1c-0.1-1.4,0.4-3.3-0.4-4.1c-0.6-0.7-2.6-0.3-4-0.3 c0-0.7,0.1-1.4,0.1-2.3c2.2,0,4.2,0,6.3,0c0,2.2,0,4.5,0,6.9C357.1,346.4,356.4,346.4,355.7,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B04821"
    },
    d: "M342.2,318.4c0-1.6,0-3.3,0-4.9C342.2,315.2,342.2,316.8,342.2,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4F25"
    },
    d: "M348.4,312.4c0,0.1,0,0.2,0,0.3C348.4,312.6,348.3,312.5,348.4,312.4 C348.3,312.4,348.4,312.4,348.4,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M349.6,341.8c0.1,1.9,0.1,3.9,0.2,5.8c-2.1,0-4.2,0-6.3,0c0-1.9,0-3.7,0-5.8 C345.6,341.8,347.6,341.8,349.6,341.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65026"
    },
    d: "M341.8,336c0,1.1-0.1,2.1-0.1,3.2c-0.7,0-1.3,0-2.1,0c0-1,0-1.8,0-2.7 C340.3,336.3,341,336.1,341.8,336z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBase);
export default __webpack_public_path__ + "static/media/bgBase.e8af59971bf6fc4b0f535c9e60c78c27.svg";
export { ForwardRef as ReactComponent };